import { Search, Trash2, Download, FilePlus, GitCompareArrows, Globe, FileText, FileDiff } from 'lucide-react';
import { SlashCommand } from './types';

export const SLASH_COMMANDS: SlashCommand[] = [
  {
    id: 'review',
    name: 'Review',
    description: 'Legal review of a document',
    icon: Search,
    type: 'skill',
    skillId: 'review',
    requiresProject: true,
    requiresFiles: true,
  },
  {
    id: 'compare',
    name: 'Compare',
    description: 'Compare two documents side by side',
    icon: GitCompareArrows,
    type: 'skill',
    skillId: 'compare',
    requiresProject: true,
    requiresFiles: true,
  },
  {
    id: 'search',
    name: 'Search',
    description: 'Research across documents and the web',
    icon: Globe,
    type: 'skill',
    skillId: 'search',
    requiresProject: false,
    comingSoon: true,
  },
  {
    id: 'summarize',
    name: 'Summarize',
    description: 'Executive summary of a document',
    icon: FileText,
    type: 'skill',
    skillId: 'summarize',
    requiresProject: true,
    requiresFiles: true,
    comingSoon: true,
  },
  {
    id: 'redline-summary',
    name: 'Redline Summary',
    description: 'Summarize tracked changes and comments',
    icon: FileDiff,
    type: 'skill',
    skillId: 'redline-summary',
    requiresProject: true,
    requiresFiles: true,
    comingSoon: true,
  },
  {
    id: 'generate',
    name: 'Generate',
    description: 'Generate a new legal document',
    icon: FilePlus,
    type: 'action',
  },
  {
    id: 'export',
    name: 'Export',
    description: 'Export document with accepted changes',
    icon: Download,
    type: 'action',
    requiresProject: true,
    requiresFiles: true,
  },
  {
    id: 'clear',
    name: 'Clear',
    description: 'Clear conversation history',
    icon: Trash2,
    type: 'action',
  },
];
